"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const scale_1 = require("../../utils/scale");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const BorderButton = (props) => {
    const { title, style = {}, textStyle = {}, onPress } = props;
    return (react_1.default.createElement(react_native_1.Pressable, { onPress: onPress, 
        // @ts-ignore
        style: ({ hovered, pressed }) => [styles.button, hovered && styles.hoverBg, pressed && styles.focusBg, style] },
        react_1.default.createElement(CustomText_1.default, { style: [styles.text, textStyle] }, title)));
};
exports.default = BorderButton;
const styles = react_native_1.StyleSheet.create({
    button: {
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth: (0, scale_1.scale)(1),
        borderRadius: (0, scale_1.scale)(3),
        borderColor: '#1960B0',
        backgroundColor: '#FEFEFE',
        ...react_native_1.Platform.select({
            web: {
                transitionProperty: 'all',
                transitionDuration: '300ms',
                transitionTimingFunction: 'ease',
            },
        }),
    },
    text: {
        fontSize: (0, scale_1.moderateScale)(12),
        lineHeight: (0, scale_1.moderateScale)(18),
        color: '#1960B0'
    },
    hoverBg: {
        backgroundColor: '#F2F7FD',
    },
    focusBg: {
        backgroundColor: '#E4EDFA',
    }
});
